import { c as _c } from "react/compiler-runtime";
import { ProjectsCarousel } from "@/components/carousel/ProjectsCarousel";
import { HighlightedList } from "@/components/HighlightedList";
const workSectionContent = {
  description: {
    text: "Explore some of the projects I have worked on.",
    secondPart: "Using technologies like",
    highlights: ["React", "Next.js", "TypeScript", "JavaScript", "Tailwind CSS"],
    end: "."
  }
};
interface WorkSectionProps {
  title: string;
}
export const WorkSection = t0 => {
  const $ = _c(9);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h1 id="work-heading" className="heading-1 mb-6 text-glow">{title}</h1>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="body-large">{workSectionContent.description.text}{t2}{workSectionContent.description.secondPart}{" "}<HighlightedList items={workSectionContent.description.highlights} />{workSectionContent.description.end}</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <header className="max-w-3xl">{t1}{t3}</header>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ProjectsCarousel />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <section aria-labelledby="work-heading" className="w-full flex flex-col items-center gap-4 text-center">{t4}{t5}</section>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};